<template>
  <div class="order-card order-card-result" v-loading="loading.chatList">
    <!--      <div class="wx-head">-->
    <!--        {{ user.from.name }}-->
    <!--      </div>-->
    <div class="msg-list" ref="msgList">
      <div v-for="(item, i) in chatList" :key="i" class="msg-item">
        <span class="msg-time">{{ item.timeStamp }}</span>
        <div class="msg" :class="{'me': isMe(item)}">
          <wechat-avatar :url="isMe(item) ? user.me.profile : user.from.profile"></wechat-avatar>
          <img v-if="[3,47].includes(item.msgType)" :src="item.msg | handleUrl" class="img-msg">
          <div v-else-if="item.msgType === 49" class="msg-content">
            <a :href="item.msg | handleUrl" class="msg-file" target="_blank">[文件:{{ item.msg }}]</a>
          </div>
          <div v-else class="msg-content" :class="{msg2009: item.msgType === 2009}" v-html="item.msg"></div>
        </div>
      </div>
    </div>
    <form autocomplete="off" @keydown.enter="send">
      <el-input placeholder="请输入内容" v-model="sendMsg" class="input-with-select" :disabled="loading.sending" ref="sendMsg">
        <el-button slot="append" :icon="loading.sending ? 'el-icon-loading':'el-icon-s-promotion'" @click="send">发送</el-button>
      </el-input>
    </form>
  </div>
</template>

<script>
import appConfig from "@/app-config";
import WechatAvatar from "@/components/WechatAvatar";
import {wechatMsgEntityHandle} from "@/components/WechatMsgHandle";
import mySocket from "@/components/mySocket";

export default {
  name: "Wechat",
  components: {WechatAvatar},
  props: {
    wechatId: {
      type: String,
    }
  },
  data () {
    return {
      loading: {
        sending: false,
        chatList: true
      },
      sendMsg: '',
      chatList: [],
      user: {
        me: {},
        from: {}
      },
      mySocket: null
    }
  },
  methods: {
    profile (msg) {
      let url = msg.msgSource ? this.user.me.profile : this.user.from.profile
      return url.startsWith('http') ? url : this.oss + url;
    },
    send () {
      if (this.loading.sending) return
      this.loading.sending = true
      this.$post('/wx/create-msg-send-task', {
        to: this.user.from.wechatId,
        msg: this.sendMsg,
      }, () => {
        this.sendMsg = ''
        setTimeout(() => {
          this.$refs.sendMsg.focus()
        }, 50)
        this.loading.sending = false
      }, () => this.loading.sending = false)
    },
    jumpEnd () {
      let $msg = this.$(this.$refs.msgList)
      let _msg = $msg.get(0)
      $msg.animate({
        scrollTop: _msg.scrollHeight - _msg.clientHeight
      }, 200)
    },
    isMe (msgData) {
      // 是否是自己发送的消息
      if (msgData.msgType === 2009) {
        return [3, 4].includes(msgData.msgSource)
      }
      return msgData.msgSource === 1
    },
    loadData () {
      this.chatList = []
      if (!this.wechatId) {
        this.loading.chatList = false
        return
      }
      this.loading.chatList = true
      // eslint-disable-next-line no-constant-condition
      if (1) return;
      this.$get('/wx/chat-record', {wechatId: appConfig.wxid, fromWxid: this.wechatId}, res => {
        this.user.me = res.me
        this.user.from = res.from
        let list = Array.from(res.msg, item => {
          item = wechatMsgEntityHandle(item)
          item.msg = this.$string2emoji(item.msg)
          return item
        })
        list.reverse()
        this.chatList = list

        setTimeout(() => {
          this.loading.chatList = false
          this.jumpEnd()
        }, 50)
      })
    }
  },
  watch: {
    wechatId (newId) {
      this.loadData(newId)
    }
  },
  created () {
    let self = this
    this.mySocket = mySocket.create({
      onmessage (msg) {
        // {"timeStamp":"1686322476130","membercount":0,"msg":"13","msgType":1,"fromType":1,"signature":"v1_dn08ZG2z","fromWxid":"jiangshan873217486","atWxidList":[],"finalFromWxid":"","msgBase64":"MTM=","silence":0,"msgSource":0}
        if (msg.type === 0 && self.wechatId === msg.data.fromWxid) {
          self.$get('/wx/set-readed', {
            wechatId: appConfig.wxid,
            fromWxid: msg.data.fromWxid
          })
          self.chatList.push(wechatMsgEntityHandle(msg.data))
          setTimeout(() => {
            self.jumpEnd()
          }, 50)
        }
      }
    })
    this.loadData()
  },
  beforeDestroy () {
    this.mySocket.close()
  }
}
</script>
<style>
.msg-item .msg img.qqface {
  height: auto !important;
  width: 280px !important;
}

.msg-item .msg .wx-avatar, .msg-item .msg img {
  height: 30px !important;
  width: 30px !important;
  margin-right: 5px;
}

.msg-item .msg.me .wx-avatar, .msg-item .msg.me img {
  margin-right: unset;
  margin-left: 5px;
}
</style>
<style scoped>

.main {
  position: absolute;
  right: 42px;
  bottom: 120px;
  width: 0;
  display: flex;
  flex-direction: row-reverse;
}

.btn {
  position: absolute;
  bottom: 0;
  width: 40px;
  height: 40px;
  z-index: 100;
  background: white url("/static/tf.svg") center/ 80% no-repeat;
  border-radius: 50%;
  transition: transform .2s ease;
  cursor: pointer;
}

.btn:hover {
  transform: scale(1.1);
}

.menu {
  background: white;
  position: absolute;
  inset: auto 0 60px auto;
  border-radius: 2px;
  width: 200px;
  padding: 8px 4px;
}

.menu-item {
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 30px;
  padding: 0 16px;
}

.menu-item i {
  margin-right: 8px;
}

.menu-item:hover {
  background: rgba(25, 55, 88, .04);
}

.order-card {
  bottom: 0;
  z-index: 200;
  margin: 0;
}

.order-card-result {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.msg-list {
  border-radius: 2px;
  background: #f3f3f3;
  padding: 10px;
  max-height: 60vh;
  overflow: auto;
  width: calc(100% - 20px);
  height: 100ch;
}

.msg-item {
  margin-bottom: 15px;
}

.msg {
  display: flex;
}

.msg.me {
  flex-direction: row-reverse
}

.msg.me .el-avatar {
  margin-right: unset;
  margin-left: 5px;
}

.msg .el-avatar {
  flex: none;
  height: 30px;
  width: 30px;
  margin-right: 5px;
}

.msg-img {
  object-fit: contain;
  max-height: 100px;
  height: 200px;
}

.msg-content {
  background-color: white;
  padding: 10px;
  max-width: calc(100% - 50px);
  word-break: break-all;
  border-radius: 2px
}

.msg-file {
  text-decoration: underline;
}

.msg-content.msg2009 {
  background: #fa9c3e;
  color: white;
}

.msg-time {
  font-size: 10px;
  color: #ccc;
  text-align: center;
  display: block;
  margin-bottom: 5px;
}

.msg-content-err {
  border: 1px solid #b15555;
}

.msg-result {
  max-width: 100%;
  margin-top: 5px;
  font-size: 12px;
  display: flex;
  color: #55b15c;
}

.msg-result:last-child {
  margin-bottom: 20px;
}

.msg-result-error {
  color: #b15555;
}

.msg-result-num {
  margin-right: 5px;
}

.msg-result-reason {
  word-break: break-all;
  overflow: hidden;
  -webkit-line-clamp: 3;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.import {
  margin: 20px 0 10px;
  text-align: right;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}

.import-tip {
  font-size: 12px;
  color: #464646;
  margin-right: 5px;
}

.msg-item .msg img.img-msg {
  max-width: 200px;
  max-height: 200px;
  height: auto !important;
  width: auto !important;
  border-radius: 2px;
}

</style>